import React from 'react';
import { Container, Divider, List, Label, Loader, Dimmer, Popup, Icon, Button, Image } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
let customFontFam = "Roboto,'Helvetica Neue',Arial,Helvetica,sans-serif"
    
const formatTime = (totalSeconds) => {
  if (isNaN(totalSeconds) || totalSeconds < 0) return '00:00';
  
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  
  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
};

export const YugtunLoader = (props) => (
  <Dimmer active={props.criteria}>
    <Loader size='massive'>
      Iñupiaq is loading...
    </Loader>
  </Dimmer>
);

// let customFontFam = "Roboto,'Helvetica Neue',Arial,Helvetica,sans-serif"
export const speakerPictures = {


"Ephim Moonin":"EphimMoonin.png",

"Florence Pestrikoff":"Florence_Pestrikoff.png",
"Fred Coyle":"FredCoyle.png",
"Irene Coyle":"IreneCoyle.png",






"Nick Aloki":"NickAlokli.png",
"Paul Kahutak":"PaulKahutak.png",
"Phyllis Peterson":"Phyllis_Peterson.png",
"Rhoda Moonin":"RhodaMoonin.png",
"Sally Ash":"SallyAsh.png",
"Sally Carlough":"Sally_Carlough.png",
"Sophie Shepherd":"Sophie_Shepherd.png",
"Dennis Knagin":"Dennis_Knagin.png",
"Mary Haakanson":"Mary_Haakanson.png",
"Clyda Christiansen":"ClydaChristiansen.jpg",

"John Pestrikoff":"JohnPestrikoff.png",

"Kathryn Chichenoff":"Kathryn_Chichenoff.png",










}

export const legenddict = {

"vi":["intransitive verb",`<span>A verb that takes an ending that marks for subject only.</span>`,"<span>Ner'ua  -  <i>I am eating.</i> <br> Asirtuten-qaa?  -  <i>Are you good?</i></span>","16","35","",""],
"vt":["transitive verb",`<span>A verb that takes an ending that marks for subject and direct object.</span>`,"<span>Qunukamken - I love you. <br> Nukallpiam arnaq niu’uquraa. - The man is talking to the woman.</span>","16","74","",""],
"vp":["verb phrase",`<span>A verb phrase has a verb and may include nouns and other dependent verbs.</span>`,"<span></span>","","","",""],
"n":["noun",`<span>A noun is a person, place, or thing.</span>`,"<span>arnaq - woman <br> qik'rtaq - island</span>","16","29","",""],
"np":["noun phrase",`<span>A noun phrase is a group of connected nouns.</span>`,"<span>qat’sqaq tengausqaq - the white airplane <br> stuulum qaingani - on top of the table</span>","","","",""],
"dem_pro":["demonstrative pronoun",`<span>Demonstrative pronouns are used to identify or point to specific people, places, or things based on where they are, what time, or context. In English, "this", "that", and "those" are demonstrative pronouns.</span>`,"<span>una - this one (by me, us) <br> taugna - that one (by you)</span>","16","49","15","62"],
"dem_adv":["demonstrative adverb",`<span>Demonstrative adverbs are used to indicate where, what manner, or time a verb is taking place. In English, "here" and "there" are demonstrative adverbs.</span>`,"<span>gwani - here (by me) <br> tawani - there (by you)</span>","16","95","15","87"],
"postbase":["postbase",`<span>Postbases are word parts that go after a noun or verb root. These modify the meaning of the root and can allow nouns to become verbs and verbs to become nouns.</span>`,"<span>Maqi<b>yug</b>tuq. - S/he <b>wants to</b> take a banya. <br> Nuusir<b>yug</b>tuq. - S/he <b>wants</b> a knife.</span>","16","29","",""],
"enclitic":["enclitic",`<span>Enclitics are word parts that attach with a hyphen after a word ending.</span>`,"<span>Qayu<b>-mi</b> pit? - How are you<b>(, I wonder)</b>? <br> Caayurturtuten<b>-qaa</b>? - Are you drinking tea <b>(yes/no)</b>?</span>","16","52","",""],
"per_pro":["personal pronoun",`<span>Personal pronouns refer to different persons in speech. In English, these are words like "I","she","they", and "it".</span>`,"<span>gui - I/me <br> ellpet - you</span>","16","48","",""],
"quant_base":["quantifier root",`<span>Quantifier bases are a special class of words that behave partly like nouns and partly like verbs. The main </span>`,"<span>kiima - only me <br> tamamta - all of us</span>","15","267","",""],
"sg":["singular",`<span>Singular means only one thing is being referenced.</span>`,"<span>nuna - land/village <br> iqalluk - one salmon</span>","16","32","",""],
"du":["dual",`<span>Dual means two things are being referenced.</span>`,"<span>nunak - two lands/villages <br> iqalluuk - two salmon</span>","16","32","",""],
"pl":["plural",`<span>Plural means three or more things are being referenced.</span>`,"<span>nunat - three or more lands/villages <br> iqalluut - three or more salmon</span>","16","32","",""],
"poss":["possessed",`<span>Something possesses this noun. The ending will change based on the person and number of the possessor and the number of the noun possessed.</span>`,"<span>qainga - the top of it <br> aanaqa/maamaqa - my mom</span>","16","155","",""],
"1st":["first person",`<span>First person refers to oneself, the speaker ("I","me","we","us").</span>`,"<span></span>","16","34-35","",""],
"2nd":["second person",`<span>Second person refers to the listener ("you","y'all").</span>`,"<span></span>","16","34-35","",""],
"3rd":["third person",`<span>Third person refers to someone/something that is neither the speaker nor the listener ("he","she","it","they","them").</span>`,"<span></span>","16","34-35","",""],
"3rd_R":["third person reflexive",`<span>The reflexive form is also third person but used in the case where the possessor or dependent verb is the same as the subject of the primary verb.</span>`,"<span></span>","16","115","",""],
"abs":["absolutive case",`<span>Absolutive noun case is considered the "unmarked" form of a noun. It is used in equational sentences, as the subject in an intransitive verb, and the direct object of transitive verbs.</span>`,"<span>nuna - land/village</span>","16","54","",""],
"rel":["relative case",`<span>Relative noun case is used as the subject of transitive verbs, and the possessor of possessed nouns.</span>`,"<span>nunam - of the land/village; the land's/village's</span>","16","55","",""],
"loc":["locative case",`<span>Locative noun case indicates the location of a noun ("in"/"at"/"on"). </span>`,"<span>nunami - in/at the land/village</span>","16","91","",""],
"all":["allative case",`<span>Allative noun case indicates going "to", "towards", or "for" a noun.</span>`,"<span>nunamen - to the land/village</span>","16","92","",""],
"abl":["ablative case",`<span>Ablative noun case indicates coming "from" a noun, and it used as an oblique object which is not marked in a verb ending.</span>`,"<span>nunamek - from the land/village</span>","16","93","",""],
"perl":["perlative case",`<span>Perlative noun case indicates going "by way of", "via", "through", or "along" a noun.</span>`,"<span>nunagun - by way of the land/village</span>","16","94","",""],
"compar":["comparative case",`<span>Comparative noun case indicates "like" a noun.</span>`,"<span>nunat'stun - like the land/village</span>","16","94","",""],
"equ":["equational sentence",`<span>Equational sentences are sentences that do not contain a verb.</span>`,"<span>Una yaamaq. - This is a rock. <br> Naama nuusiq? - Where is the knife?</span>","16","33","15","15"],
"ind_non_past":["indicative non-past mood",`<span>The indicative non-past mood is used for statements and yes/no questions that are present or future.</span>`,"<span>Qawartut. - They are sleeping.</span>","16","144","",""],
"ind_past":["indicative past mood",`<span>The indicative past mood is used for statements and yes/no questions that are in the past. </span>`,"<span>Qawallriit. - They were sleeping.</span>","16","145","",""],
"interr":["interrogative mood",`<span>The interrogative mood is used for open-ended questions (who, what, where, when, why, how) and not yes/no questions.</span>`,"<span>Nani qawartat? - Where are they sleeping?</span>","16","60,167","",""],
"opt_imp":["optative-imperative mood",`<span>The optative-imperative mood is used for commands. Optative is for 1st person endings (I, we) and imperative for 2nd person (you).</span>`,"<span>Aqumi! - Sit down! <br> Aglita! - Let's go!</span>","16","59","",""],
"sub":["subordinative mood",`<span>The subordinative mood is used in narratives and storytelling, and when a verb attaches to a primary verb.</span>`,"<span>Naaqiuq aqumaluni. - She is reading while sitting.</span>","16","34,57","",""],
"conseq":["consequential mood",`<span>The conseqential mood means "because...".</span>`,"<span></span>","15","296","",""],
"cond":["conditional mood",`<span>The conditional mood means "if/when...".</span>`,"<span></span>","15","296","",""],
"cont":["contingent mood",`<span>The contingent mood means "whenever...".</span>`,"<span></span>","15","296","",""],
"concess":["concessive mood",`<span>The concessive mood means "although, even though, even if...".</span>`,"<span></span>","15","296","",""],
"precess":["precessive mood",`<span>The precessive mood means "before...".</span>`,"<span></span>","15","296","",""],
"quant_end":["quantifier ending",`<span>This special set of endings are used with quantifier roots, personal pronouns, and postural verbs.</span>`,"<span></span>","15","268","",""],
"pred":["predicative form",`<span>Demonstrative adverbs have a special predicative form ending in -'i to make it act like a verb.</span>`,"<span>gwa'i - here (it is) <br> tawa'i - there (it is)</span>","15","87","",""],









}

export const AudioSource = (data) => {
  console.log(data)
  var activeAudioIndex = data.activeAudioIndex;
  var content = data.activeAudioIndex.content;
  var index = data.index;
  let pictureWidth = 150
  let startTime = Math.round(content.startTime)
  const minutes = Math.floor(startTime / 60);
  const seconds = startTime % 60;

  // Add a leading zero to seconds if it is less than 10
  const formattedSeconds = seconds < 10 ? `0${seconds}` : seconds;

  // return (content.type == 'interview' ? 
  return  <List.Item style={{paddingTop:5,marginTop:8,backgroundColor:'#faf9f6'}}>
          <List.Content style={{padding:(window.innerWidth < 480 ? '0px 20px' : '0px 50px')}}>
            {content.type == 'interview' || content.type == 'story' ? 
            <div style={{marginBottom:'15px'}}>
            <List.Description style={{fontSize:'16px',color:'#000000DE',fontWeight:'400',lineHeight:'23px',marginTop:'5px'}}>
            <div style={{marginBottom:'12px'}}><span style={{borderBottom:'1px solid rgb(133, 133, 133)',paddingBottom:'1px'}}>{'Text Source: '}</span></div>
            </List.Description>

            <List.Description style={{fontSize:'16px',color:'#000000DE',fontWeight:'400',lineHeight:'23px'}}>
            {'contextBeforeSug' in content ?
              // this.spanParses(content.contextBeforeSug,'16px',400)
              <span style={{marginRight:'6px'}}>{content.contextBeforeSug}</span>
              :
              null}

            {/*{this.spanParses(activeAudioIndex.sugtstun,'16px',600)}*/}
            <span style={{fontWeight:'bold',marginRight:'6px'}}>{activeAudioIndex.sugtstun}</span>
            {'contextAfterSug' in content ?
              // this.spanParses(content.contextAfterSug,'16px',400)
              <span>{content.contextAfterSug}</span>
              :
              null
            }
            </List.Description>

            <List.Description style={{fontSize:'16px',color:'#000000DE',fontWeight:'400',lineHeight:'23px',paddingTop:'12px'}}>
            {'contextBeforeEng' in content ?
              // this.spanParses(content.contextBeforeSug,'16px',400)
              <span style={{marginRight:'6px'}}>{content.contextBeforeEng}</span>
              :
              null}

            {/*{this.spanParses(activeAudioIndex.sugtstun,'16px',600)}*/}
            <span style={{fontWeight:'bold',marginRight:'6px'}}>{activeAudioIndex.english}</span>
            {'contextAfterEng' in content ?
              // this.spanParses(content.contextAfterSug,'16px',400)
              <span>{content.contextAfterEng}</span>
              :
              null
            }                               
            </List.Description>
            </div>
            :
            null
          }


            {'speaker' in content ?
              <List.Description style={{fontSize:'16px',color:'#000000DE',fontWeight:'400',lineHeight:'23px',marginBottom:'8px'}}>
              <div><span style={{borderBottom:'1px solid rgb(133, 133, 133)',paddingBottom:'1px'}}>{'Speaker and Audio Source: '}</span></div>
              </List.Description>
              :
              <List.Description style={{fontSize:'16px',color:'#000000DE',fontWeight:'400',lineHeight:'23px',marginBottom:'8px'}}>
              <div><span style={{borderBottom:'1px solid rgb(133, 133, 133)',paddingBottom:'1px'}}>{'Audio Source: '}</span></div>
              </List.Description>
            }


            {'speaker' in content ?
              <List.Description style={{fontSize:'16px',color:'#000000DE',fontWeight:'400',lineHeight:'23px',marginTop:'15px'}}>
                {content['speaker'] in speakerPictures ?
                  <div>
                    <div href={content.link} target="_blank" style={{color:'#306190',width:pictureWidth}}>
                      <Image style={{cursor:'pointer',borderRadius:'15px'}} src={'speakers/'+speakerPictures[content['speaker']]} />
                    </div>
                    <div style={{paddingBottom:'4px',width:pictureWidth,paddingTop:4,textAlign:'center'}}>
                      <span style={{marginRight:'6px'}}>{content.speaker}</span>
                    </div>
                  </div>
                  :
                  <div style={{paddingBottom:'4px'}}>
                    <span style={{marginRight:'6px',fontStyle:'italic'}}>{content.speaker}</span>
                  </div>
                }
              </List.Description>
              :
              null
              
            }

{/*             {'speaker' in content ?
              <List.Description style={{fontSize:'16px',fontStyle:'italic',color:'#000000DE',fontWeight:'400',lineHeight:'23px',paddingBottom:'12px',textAlign:'center',width:pictureWidth,paddingTop:4}}>
              <span style={{marginRight:'6px'}}>{content.speaker}</span>
              </List.Description>
                :
                null
              }
*/}
            <List.Description style={{fontSize:'16px',color:'#000000DE',fontWeight:'400',lineHeight:'23px',paddingTop:'8px'}}>
              <span>{'Link to Recording: '}</span><a href={content.link} target="_blank" style={{cursor:'pointer'}}>{content.source}</a>
            </List.Description>
            {'startTime' in content ?
              <List.Description style={{fontSize:'16px',color:'#000000DE',fontWeight:'400',lineHeight:'23px',paddingTop:'5px'}}>
                Timestamp: <span>{String(minutes)+'m '+String(formattedSeconds)+'s'}</span>
              </List.Description>
              :
              null
            }


{/*                                  {word.obj.key.split('_')[0] in tlingitConversationData ?
              (tlingitConversationData[word.obj.key.split('_')[0]][2].map((k)=>
                (k in speakerIDs ? 
                <List.Description style={{fontSize:'16px',color:'#000000DE',fontWeight:'400',lineHeight:'23px',marginTop:'15px',marginBottom:'10px'}}> 
                <div style={{fontSize:'16px', lineHeight:'21px', marginBottom:'15px', paddingLeft:'6px',borderLeft:'solid 1px #d3d3d3'}}>

                {speakerIDs[k][0].length > 0 ? <div><span style={{fontWeight:500}}>{speakerIDs[k][0]}</span></div> : null}
                {speakerIDs[k][2].length > 0 ? <div>Clan: <span>{speakerIDs[k][2]}</span></div> : null}
                {speakerIDs[k][3].length > 0 ? <div>Father's Clan: <span>{speakerIDs[k][3]}</span></div> : null}
                {speakerIDs[k][4].length > 0 ? <div>Village or K̲waan: <span>{speakerIDs[k][4]}</span></div> : null}
                {speakerIDs[k][5].length > 0 ? <div>Clan House: <span>{speakerIDs[k][5]}</span></div> : null}

                </div>
                </List.Description>
                :
                null
                )
              ))
              :
              null
            }
*/}
            <div style={{height: '10px'}} />
          </List.Content>
    </List.Item>   
//     :
//     <List.Item>
//           <List.Content style={{marginTop:10,padding:(window.innerWidth < 480 ? '0px 20px' : '0px 50px')}}>
//           <List.Description style={{fontSize:'16px',color:'#000000DE',fontWeight:'400',lineHeight:'23px',marginTop:'15px'}}>
//           <div><span style={{borderBottom:'1px solid rgb(133, 133, 133)',paddingBottom:'1px'}}>{'Source: '}</span></div>
//           </List.Description>

// {/*          {'image' in content ?
//             <List.Description style={{fontSize:'16px',color:'#000000DE',fontWeight:'400',lineHeight:'23px',marginTop:'15px'}}>
//               <a href={content.link} target="_blank" style={{color:'#306190',width:'100px'}}>
//                 <Image style={{cursor:'pointer',height:'200px'}} src={'curriculum.png'}/>
//               </a>
//             </List.Description>
//             :
//             null
//           }*/}

//           <List.Description style={{fontSize:'16px',color:'#000000B3',fontWeight:'400',lineHeight:'23px',paddingTop:'8px'}}>
//             <a href={content.link} target="_blank" style={{cursor:'pointer'}}>{content.source}</a>
//           </List.Description>
//           {'location' in content ?
//             <List.Description style={{fontSize:'16px',color:'#000000DE',fontWeight:'400',lineHeight:'23px',paddingTop:'5px'}}>
//               Location: <span>{content.location}</span>
//             </List.Description>
//             :
//             null
//           }
//           <div style={{height: '10px'}} />

//         </List.Content>
//     </List.Item>                                              
//     )     
}


export const processStyledText = (sentence) => {
      // sentence = sentence.replaceAll(">","")


      sentence = sentence.replaceAll("⟨","").replaceAll("⟩","")
      let matches = sentence.match(/⎡.*?⎤/g)
      let matches1 = sentence.match(/{.*?}/g)
      let matches2 = sentence.match(/_.*?_/g)
      // console.log(matches2)
      if (matches !== null || matches1 !== null || matches2 !== null) {
        if (matches !== null) {
          matches.map((m) => sentence = sentence.replaceAll(m,'<i>'+m.slice(1,-1)+'</i>'))           
        }
        if (matches1 !== null) {
          matches1.map((m) => sentence = sentence.replaceAll(m,m.slice(1,-1)))            
        }
        if (matches2 !== null) {
          matches2.map((m) => sentence = sentence.replace(m,'<sub>'+m.slice(1,-1)+'</sub>'))            
        }
        return <span dangerouslySetInnerHTML={{__html: sentence}} />    
      } else {
        return <span>{sentence}</span>
      }


      // let matches = sentence.match(/\⎡.*?\⎤/g)
      // if (matches !== null) {
      //   matches.map((m) => sentence = sentence.replaceAll(m,'<i>'+m.slice(1,-1)+'</i>'))   
      //   return <span dangerouslySetInnerHTML={{__html: sentence}} />    
      // } else {
      //   return <span>{sentence}</span>
      // }
    }


export const processStyledTextLink = (sentence) => {
      sentence = sentence.replaceAll(">","")


      sentence = sentence.replaceAll("⟨","").replaceAll("⟩","").replaceAll("↞","").replaceAll("&","").replaceAll("↠","")
      let matches = sentence.match(/⎡.*?⎤/g)
      let matches1 = sentence.match(/{.*?}/g)
      let matches2 = sentence.match(/_.*?_/g)
      // console.log(matches2)
      if (matches !== null || matches1 !== null || matches2 !== null) {
        if (matches !== null) {
          matches.map((m) => sentence = sentence.replaceAll(m,'<i>'+m.slice(1,-1)+'</i>'))           
        }
        if (matches1 !== null) {
          matches1.map((m) => sentence = sentence.replaceAll(m,m.slice(1,-1)))            
        }
        if (matches2 !== null) {
          matches2.map((m) => sentence = sentence.replace(m,'<sub>'+m.slice(1,-1)+'</sub>'))            
        }
        return <span style={{whiteSpace:'nowrap'}} dangerouslySetInnerHTML={{__html: sentence}} />    
      } else {
        return <span style={{whiteSpace:'nowrap'}}>{sentence}</span>
      }


      // let matches = sentence.match(/\⎡.*?\⎤/g)
      // if (matches !== null) {
      //   matches.map((m) => sentence = sentence.replaceAll(m,'<i>'+m.slice(1,-1)+'</i>'))   
      //   return <span dangerouslySetInnerHTML={{__html: sentence}} />    
      // } else {
      //   return <span>{sentence}</span>
      // }
    }

export const NewUsageBaseDisplay = (k) => {
    let returnNewUsageBaseDisplayLabel = {
      'verb phrase':[
        'present',
        'past',
        'question',
        'polite command',
        'command',
      ],
      'noun':[
        'stem',
        'possessive',
        'locative noun case',
        'with pronoun',
      ],
    }

    let word = k.word
    let state = k.state
    let props = k.props
    // console.log(word)


    return  <List.Item style={{paddingBottom:'8px',paddingTop:'15px'}}>
              <List.Content style={{fontSize:'16px',paddingBottom:'10px'}}><span style={{paddingRight:'20px',fontWeight:'500'}}>{word.url.replaceAll(',',', ')}</span><span style={{paddingRight:'15px',fontStyle:'italic'}}>{processStyledText(word.thisDefinition)}</span><span style={{'marginLeft':'15px',marginRight:'6px',cursor:'pointer'}}><TagColors tags={word.t} width={window.innerWidth} /></span></List.Content>
              {word.newUsageDefinitions.map((u,uindex)=>
              <List.Content style={{paddingLeft:'20px'}}>
                <Link to={{pathname: '/wordbuilder/' + word.url, state: {initBackendCall:word.backendCalls[uindex],usagedictionary_dict: word.usagedictionary_dict, activeKeyInEditIndex:0, value1: 's31-1(1)',value2: 'o31-3(2)', nounvalue1: '1', nounvalue2: '00(3)', fullDefinition: word.fullDefinition, word: word.usageWord, num: word.num, usageDefinition: word.usageDefinition, from: props.location.pathname, history:[state.search,state.wordsList,state.Yposition, state.activeTabIndex] }}}>
                  <List.Content floated='right'>
                    <Icon circular style={{marginTop:'3px', color:'#8f8f8f'}} size='small' name='chevron right' />
                  </List.Content>
                </Link>
                <List.Content style={{display:'flex',fontSize:'16px',paddingBottom:'8px',fontFamily:customFontFam,lineHeight:'25px'}}>
                  <span style={{flex:2,'paddingRight':'3px',fontWeight:'500'}}>
                  <Link style={{borderBottom:'1px solid #858585',paddingBottom:'1px',color:'#306190'}} to={{pathname: '/wordbuilder/' + word.url, state: {initBackendCall:word.backendCalls[uindex],usagedictionary_dict: word.usagedictionary_dict, activeKeyInEditIndex:0, value1: 's31-1(1)',value2: 'o31-3(2)', nounvalue1: '1', nounvalue2: '00(3)', fullDefinition: word.fullDefinition, word: word.usageWord, num: word.num, usageDefinition: word.usageDefinition, from: props.location.pathname, history:[state.search,state.wordsList, state.Yposition, state.activeTabIndex] }}}>
                  {processStyledTextLink(word.usageWords[uindex])}
                  </Link>
                  {word.audioMatrix[uindex] ?
                    <Button onClick={()=>this.repeatAudio(word.audioMatrix[uindex])} style={{paddingLeft:'7px',fontSize:'14px',color:'#4e7498'}} icon='volume up' />
                    :
                    null
                  }
                  </span>
                  <span style={{flex:5,fontSize:'16px',color:'#000000cc',fontWeight:'400',lineHeight:'23px',paddingTop:'4px'}}>{processStyledText(word.newUsageDefinitions[uindex])}</span>
                  <span style={{flex:3,color:'#BEBEBE',fontStyle:'italic',textAlign:'right'}}>{returnNewUsageBaseDisplayLabel[word.t][uindex]}</span>
                </List.Content>
              </List.Content>
              )}
            </List.Item>  
}

export const TagColors = (props) => {
  // console.log(props)
  // let isParticle = props.tags.includes('particle');
  // let isExclamation = props.tags.includes('exclamation');
  // let isConjunction = props.tags.includes('conjunction');
  // let isAdverb = props.tags.includes('adverb');
  // let isPredicate = props.tags.includes('predicate');
  // let isDemonstrative = props.tags.includes('demonstrative');
  // let isInterjection = props.tags.includes('interjection');
  // let isPostbase = props.tags.includes('postbase');
  // let isEnclitic = props.tags.includes('enclitic');

  let upperCase = props.tags
  let width = props.width
  let size = props.size

  // if (upperCase.length > 0) {
  //   if (upperCase[0] == '!') {
  //     upperCase = upperCase.slice(1)
  //   }
  // }
  // console.log(props)
  let english = ''

  var tagDict = legenddict
// var tagDict = {

// "n":["noun"],
// "vi":["verb intransitive"],
// "vt":["verb transitive"],
// "dem_pro":["demonstrative pronoun"],
// "dem_adv":["demonstrative adverb"],
// "per_pro":["personal pronoun"],
// "quant_base":["quantifier base"],
// "np":["noun phrase"],
// "vp":["verb phrase"],
// "abs":["absolutive"],
// "rel":["relative"],
// "loc":["locative"],
// "all":["allative"],
// "2all":["second allative"],
// "abl":["ablative"],
// "perl":["perlative"],
// "compar":["comparative"],
// "incl":["inclusive"],
// "pred":["predicative"],
// "ind_pres":["indicative present"],
// "ind_past":["indicative past"],
// "interr":["interrogative"],
// "opt_imp":["optative-imperative"],
// "conj":["conjunctive"],
// "conseq":["consequential"],
// "cond":["conditional"],
// "cont":["contingent"],
// "concess":["concessive"],
// "precess":["precessive"],
// "quant_end":["quantifier ending"],
// "equ":["equational sentence"],
// "poss":["possessed"],
// "sg":["singular"],
// "du":["dual"],
// "pl":["plural"],
// "postbase":["postbase"],

// // "adverb":["Adverb","Qanuq, Sukun, Summan Suraġaġmagaaġun ","Qanuq,..."," - How, When, Why Something is/was done."],
// // "tat":["prefix used when providing more emphasis or information referring back to a previously mentioned thing, or when the entity is closer and visible to the listener","(tat-)","(tat-)",""],
// // "res":["restricted and visible","(r, v)","(r, v)"," - occupying a restricted area or stationary"],
// // "ext":["extended and visible","(e, v)","(e, v)"," - occupying a large area or in motion"],
// // "not":["not visible","(not v)","(not v)",""],
// // "¤unconfirmed":["Unconfirmed","¤ Iluaġmagaaġutaiḷaq","¤ Iluaġm...",""],
// // "Anaqtuuvak":["Anaqtuuvak","Anaqtuuvak","Anaqtu..."," - Anaktuvuk Pass Dialect"],
// // "Nuvuk":["Nuvuk","Nuvuk","Nuvuk..."," - Point Barrow Dialect"],
// // "Tikiġaq":["Tikiġaq","Tikiġaq","Tikiġa..."," - Point Hope Dialect"],
// // "Ulġuniq":["Ulġuniq","Ulġuniq","Ulġuni..."," - Wainwright Dialect"],
// // "verb stem":["Verb Stem","Suraġaġniġum Maŋŋua","Suraġa..",""],
// // "VERB":["Verb Stem","Suraġaġniġum Maŋŋua","Suraġa..",""],
// // "(t) TRANSITIVE VERB":["(t) Transitive Verb","Nalunaiŋaruk Suraġaqtilu Suraġaqtaġlu","Naluna..."," - 'Subject And Object Are Marked'  - Ending with Subject and Direct Object"],
// // "(i) INTRANSITIVE VERB":["(i) Intransitive Verb","Nalunaiŋaruq Suraġaqti","Naluna..."," - 'Subject is Marked' - Ending with Subject Only"],
// // "verb phrase":["Verb Phrase","Suraġaġniq","Suraġa...",""],
// // "ablative":["Ablative","Sumiñŋaqtilaaġun","Sumiñŋ..."," - From what or where"],
// // "absolutive":["Absolutive","Inmiguallaruaq","Inmigu...",""],
// // "noun case":["Noun Case","Atiqausim Isua","Atiqau..."," - Endings for nouns"],
// // "conjunction":["Conjunction","Iḷagiigutaq","Iḷagi..."," - Indicator of being with others"],
// // "contemporative":["Contemporative","Atautchikuaġun Uqallaun","Atautc..."," - Happening at same time statement"],
// // "deep root":["Deep Root","Maŋŋuġruaq","Maŋŋuġ...",""],
// // "demonstrative adverb":["Demonstrative Adverb","Tikkuaġaun ","Tikkua...",""],
// // "demonstrative pronoun":["Demonstrative Pronoun","Tikkuaġaun Atiqausiqqayaq","Tikkua...",""],
// // "demonstrative stem":["Demonstrative Stem","Tikkuaġautim Maŋŋua","Tikkua...",""],
// // "discourse marker":["Discourse Marker","Uqaqtuni Ikayuun","Uqaqtu..."," - Helper when talking"],
// // "dual":["Dual","Malġuk","Malġuk...",""],
// // "exclamation":["Exclamation","Uqallagaun Tupaktuni, Qinnaliqsuni, Naakka Anniqsuni","Uqalla..."," - A word said loudly when surprised, angered, or when hurt"],
// // "expression":["Expression","Uqallagniq","Uqalla...",""],
// // "indicative":["Indicative","Uqallaun Naanŋaraaq","Uqalla...",""],
// // "interjection":["Interjection","Uqallagaun Saniġatqułługu Uqausiġiraat","Uqalla..."," - A word out of the blue, usually not on subject"],
// // "interjectional":["Interjectional","Uqallagaun Saniġatqułługu Uqausiġiraat","Uqalla..."," - A word out of the blue, usually not on subject"],
// // "interrogative":["Interrogative","Uqallaun Apiqqun","Uqalla...",""],
// // "irregular":["Irregular","Inmiguaqtuaq","Inmigu..."," - Independent word"],
// // "localis":["Localis","Sumiitilaaġun","Sumiit...",""],
// // "locative":["Locative","Sumitilaaġun","Sumiti...",""],
// // "negative":["Negative","Naaggaun","Naagga...",""],
// // "possessive":["Possessive","Pimaaqtuun","Pimaaq...",""],
// // "pronoun":["Pronoun","Atiqausiqqayaq","Atiqau..."," - Almost a noun"],
// // "PRONOUN":["Pronoun","Atiqausiqqayaq","Atiqau..."," - Almost a noun"],
// // "relative":["Relative","Inmigualaitchuaq","Inmigu...",""],
// // "similaris":["Similaris","Sutin Itilaaġun","Sutin ...",""],
// // "subordinative":["Subordinative","Uqallaun Ilaagualaiḷaq","Uqalla...",""],
// // "temporal noun":["Temporal Noun","Piviksram Igliġniŋagun Atiqausiq","Piviks..."," - Time to do something noun"],
// // "terminalis":["Terminalis","Sumuktilaaġun","Sumukt...",""],
// // "toward":["Toward","Tuŋaanun","Tuŋaan...",""],
// // "vialis":["Vialis","Sukuaqtilaaġun","Sukuaq...",""],
// // "vocative":["Vocative","Tuqłuun","Tuqłuu...",""],
// // "postbase":["Postbase","Akunniġun","Akunni...",""],
// // "noun":["Noun","Atiqausiq","Atiqau...",""],
// // "root":["Root","Maŋŋuq","Maŋŋuq"," - Neither a verb stem nor noun. Cannot acquire verb or noun endings without the addition of a postbase."],
// // "*root":["Root","*Maŋŋuq","*Maŋŋuq",""],
// // "*ROOT":["Root","*Maŋŋuq","*Maŋŋuq",""],
// // "*deep root":["Root","*Maŋŋuq","*Maŋŋuq",""],
// // "stem":["Stem","Maŋŋuq","Maŋŋuq",""],
// // "half transitive":["Half Transitive Form","Skunniġun Nalunaiŋaiqsiḷḷaruaq Suraġaqtamik","Akunniġ..."," - A transitive verb stem with a postbase that enables it to use intransitive endings."],
// // "°stem":["Stem","°Maŋŋuq","°Maŋŋuq"," - The degree symbol indicates that stems are not complete words as they are but embody concepts."],
// // "°STEM":["Stem","°Maŋŋuq","°Maŋŋuq"," - The degree symbol indicates that stems are not complete words as they are but embody concepts."],
// // "°demonstrative stem":["Demonstrative Stem","°Tikkuaġautim Maŋŋua","°Tikkua...",""],
// // "°interrogative stem":["Interrogative Stem","°Maŋŋuq","°Maŋŋuq",""],
// // "N":["Noun","Atiqausiq","Atiqau...",""],
// // "NOUN*":["Noun","Atiqausiq","Atiqau...",""],
// // "dn":["postbase attaches to demonstrative to become a noun","dn","dn",""],
// // "dv":["postbase attaches to demonstrative to become a verb stem","dv","dv",""],
// // "nn":["postbase attaches to singular absolutive noun to become a noun","nn","nn",""],
// // "nv":["postbase attaches to singular absolutive noun to become a verb stem","nv","nv",""],
// // "rn":["postbase attaches to root to become a noun","rn","rn",""],
// // "rv":["postbase attaches to root to become a verb stem","rv","rv",""],
// // "vn":["postbase attaches to verb stem to become a noun","vn","vn",""],
// // "vv":["postbase attaches to verb stem to become a verb stem","vv","vv",""],
// // "wv":["postbase attaches to word to become a verb stem","wv","wv",""],
// // "limited":["indicates that the distribution of the postbase is limited","limited","limited",""],
// // "see examples1":["","see example stems","see example stems",[["aullaq-","to leave, go away, depart"],["tikit-","to arrive at"],["ai-","to go home"],["aqpat-","to run (of a human)"]]],
// // "see examples2":["","see example stems","see example stems",[["siñik-","to sleep"],["niġi-","to eat"],["aquppi-","to be sitting"],["iglaq-","to laugh"]]],

// // "modalis":["Modalis Case","Qanusiutilaaġun Qanusimik, Qanuq, Qanuqługu","Qanusi..."," - 1) Indirect object of intransitive verb. 2) Instrument or means to do an action. 3) A way to specify an object or an action."], 
// // "pro-mod":["Modalis Case","Qanusiutilaaġun Qanusimik, Qanuq, Qanuqługu","Qanusi..."," - 1) Indirect object of intransitive verb. 2) Instrument or means to do an action. 3) A way to specify an object or an action."], 
// // "adv-base":["Stative Case","Sumitilaaġun","Sumiti..."," - Directing the person to a location where something is."],
// // "adv-loc":["Locative Case","Sumitilaaġun","Sumiti..."," - Location in which an event occurs."],
// // "adv-via":["Vialis Case","Sukuaqtilaaġun","Sukuaq..."," - Through which an event occurs."],
// // "adv-abl":["Ablative Case","Sumiñŋaqtilaaġun","Sumiñŋ..."," - From whence an event occurs."],
// // "adv-2abl":["2nd Ablative Case","Sumiñŋaqtilaaġun","Sumiñŋ..."," - Origin of the movement or progression from the area indicated."],
// // "adv-ter":["Terminalis Case","Sumuktilaaġun","Sumukt..."," - Termination point of an activity."],
// // "adv-2ter":["2nd Terminalis Case","Suŋnanmuktilaaġun","Suŋnan..."," - Movement or orientation towards the area indicated."],

// // "pro-abs":["Absolutive Case","Inmiguallaruaq","Inmigu..."," - 1) Subject of intransitive verb. 2) Direct object of transitive verb."],
// // "pro-rel":["Relative Case","Inmigualaitchuaq","Inmigu..."," - 1) Subject of a transitive verb. 2) Possessor of another noun."],
// // "pro-loc":["Locative Case","Sumitilaaġun","Sumiti..."," - Place or time where or when an event occurs."],
// // "pro-ter":["Terminalis Case","Sumuktilaaġun","Sumukt..."," - 1) Place, time, or entity where an event or action stops, concludes. 2) Subject of embedded verb."],
// // "pro-abl":["Ablative Case","Sumiñŋaqtilaaġun","Sumiñŋ..."," - 1) Origin of an item or an event. 2) Source of comparison."],
// // "pro-via":["Vialis Case","Sukuaqtilaaġun","Sukuaq..."," - 1) Venue, time, entity, or circumstances through which an event occurs. 2) Source of a comparison of differences."],
// // "pro-sim":["Similaris Case","Sutin Itilaaġun","Sutin ..."," - Similarities between entities."],

// // 'demAdvAblVerb':["Verb stem of demonstrative root with an ablative postbase","Suraġaġniġum Sumiñ Tikuaġutaata Maŋŋua","Suraġa...",""],
// // 'demAdvTerVerb':["Verb stem of demonstrative root with a terminalis postbase","Suraġaġniġum Sumun Tikuaġutaata Maŋŋua","Suraġa...",""],
// // 'demAdvViaVerb':["Verb stem of demonstrative root with a vialis postbase","Suraġaġniġum Sukun Tikuaġutaata Maŋŋua","Suraġa...",""],
// // 'demAdvLocVerb':["Verb stem of demonstrative root with a locative postbase","Suraġaġniġum Sumi Tikuaġutaata Maŋŋua","Suraġa...",""],
// // 'rsub':["indicates co-reference (subject of a separate independent verb is the same referent as the subject of this dependent verb)","R","R",""],
// // 'robj':["indicates co-reference (subject of a separate independent verb is the same referent as the object of this dependent verb)","R","R",""],


// }

  upperCase = upperCase.toUpperCase()
  if (Object.keys(tagDict).includes(props.tags)) {

  //   if (width < 480 && width !== -1) {
  //     upperCase = tagDict[props.tags][2]

  //   } else {


  //     upperCase = tagDict[props.tags][1]
  //   }

  //   // console.log(tagDict[props.tags])
  //   if (props.tags == 'Anaqtuuvak' || props.tags == 'Nuvuk' || props.tags == 'Tikiġaq' || props.tags == 'Ulġuniq') {
    english = tagDict[props.tags][0]
  //   } else if (props.tags.length == 2) {
  //     english = tagDict[props.tags][0]
  //   } else {
  //     english = tagDict[props.tags][1]+' - '+tagDict[props.tags][0]+tagDict[props.tags][3]

  //   }

  // }
  //   if (props.tags != 'res' && props.tags != 'ext' && props.tags != 'not' && props.tags != 'tat') {
      
  //   }
    
  // console.log(props.tags)


                
  if (props.tags == 'n') {
    return <Popup position='bottom center' on='click' disabled={size === 'medium'} content={<div><span style={{fontSize:'15px'}}>{english}</span><div style={{marginTop:'10px'}}>See <Link target="_blank" to={{pathname: '/legend'}}><span style={{paddingBottom:'1px',borderBottom:'1px solid #4183c4'}}>{'Legend'}</span></Link></div></div>} trigger={<Label size={size} style={{backgroundColor:'#f6ede4',marginTop:'2px',whiteSpace:'nowrap',cursor:'pointer'}}>{'NOUN'}</Label>} />
  } else if (props.tags == 'vi') {
    return <Popup position='bottom center' on='click' disabled={size === 'medium'} content={<div><span style={{fontSize:'15px'}}>{english}</span><div style={{marginTop:'10px'}}>See <Link target="_blank" to={{pathname: '/legend'}}><span style={{paddingBottom:'1px',borderBottom:'1px solid #4183c4'}}>{'Legend'}</span></Link></div></div>} trigger={<Label size={size} style={{backgroundColor:'#e2eeea',marginTop:'2px',whiteSpace:'nowrap',cursor:'pointer'}}>{'VERB'}<span style={{fontFamily:'monospace'}}>{' I'}</span></Label>} />    
  } else if (props.tags == 'vt') {
    return <Popup position='bottom center' on='click' disabled={size === 'medium'} content={<div><span style={{fontSize:'15px'}}>{english}</span><div style={{marginTop:'10px'}}>See <Link target="_blank" to={{pathname: '/legend'}}><span style={{paddingBottom:'1px',borderBottom:'1px solid #4183c4'}}>{'Legend'}</span></Link></div></div>} trigger={<Label size={size} style={{backgroundColor:'#d2e0e8',marginTop:'2px',whiteSpace:'nowrap',cursor:'pointer'}}>{'VERB T'}</Label>} />   
  } else if (props.tags == 'np') {
    return <Popup position='bottom center' on='click' disabled={size === 'medium'} content={<div><span style={{fontSize:'15px'}}>{english}</span><div style={{marginTop:'10px'}}>See <Link target="_blank" to={{pathname: '/legend'}}><span style={{paddingBottom:'1px',borderBottom:'1px solid #4183c4'}}>{'Legend'}</span></Link></div></div>} trigger={<Label size={size} style={{backgroundColor:'#f6ede4',marginTop:'2px',whiteSpace:'nowrap',cursor:'pointer'}}>{'PHRASE'}<Icon style={{fontSize:'9px',margin:0,padding:0,marginLeft:'6px'}} name='chevron down' /></Label>} />
  } else if (props.tags == 'vp') {
    return <Popup position='bottom center' on='click' disabled={size === 'medium'} content={<div><span style={{fontSize:'15px'}}>{english}</span><div style={{marginTop:'10px'}}>See <Link target="_blank" to={{pathname: '/legend'}}><span style={{paddingBottom:'1px',borderBottom:'1px solid #4183c4'}}>{'Legend'}</span></Link></div></div>} trigger={<Label size={size} style={{backgroundColor:'#e2eeea',marginTop:'2px',whiteSpace:'nowrap',cursor:'pointer'}}>{'PHRASE'}<Icon style={{fontSize:'9px',margin:0,padding:0,marginLeft:'6px'}} name='chevron down' /></Label>} />
  // } else if (props.tags == 'np') {
    // return <Popup position='bottom center' on='click' content={<span style={{fontSize:'15px'}}>{english}</span>} trigger={<Label size='mini' style={{backgroundColor:'#fde5ce',marginTop:'2px',whiteSpace:'nowrap',cursor:'pointer'}}>{'PHRASE'}<Icon style={{fontSize:'9px',margin:0,padding:0,marginLeft:'6px'}} name='chevron down' /></Label>} />
  // } else if (props.tags == 'vp') {
    // return <Popup position='bottom center' on='click' content={<span style={{fontSize:'15px'}}>{english}</span>} trigger={<Label size='mini' style={{backgroundColor:'#cfe8e0',marginTop:'2px',whiteSpace:'nowrap',cursor:'pointer'}}>{'PHRASE'}<Icon style={{fontSize:'9px',margin:0,padding:0,marginLeft:'6px'}} name='chevron down' /></Label>} />
  // } else if (props.tags == '(i) INTRANSITIVE VERB' || props.tags == '(t) TRANSITIVE VERB' || props.tags == 'VERB') {
  //   return <Popup position='bottom center' on='click' content={<span style={{fontSize:'15px'}}>{english}</span>} trigger={<Label size='mini' style={{backgroundColor:'#f1f1f1',marginTop:'2px',whiteSpace:'nowrap'}}>{upperCase}<Icon style={{fontSize:'9px',margin:0,padding:0,marginLeft:'6px'}} name='chevron down' /></Label>} />
  } else if (props.tags == 'postbase') {
    return <Popup position='bottom center' on='click' disabled={size === 'medium'} content={<div><span style={{fontSize:'15px'}}>{english}</span><div style={{marginTop:'10px'}}>See <Link target="_blank" to={{pathname: '/legend'}}><span style={{paddingBottom:'1px',borderBottom:'1px solid #4183c4'}}>{'Legend'}</span></Link></div></div>} trigger={<Label size={size} style={{backgroundColor:'#f7e7fa',marginTop:'2px',whiteSpace:'nowrap',cursor:'pointer'}}>{upperCase}</Label>} />
  // } else if (props.tags == '*root' || props.tags == '*deep root' || props.tags == '°stem' || props.tags == '°demonstrative stem' || props.tags == '°interrogative stem') {
  //   return <Popup position='bottom center' on='click' content={<span style={{fontSize:'15px'}}>{english}</span>} trigger={<Label size='mini' style={{backgroundColor:'#ecd8d8',marginTop:'2px',whiteSpace:'nowrap'}}>{upperCase}<Icon style={{fontSize:'9px',margin:0,padding:0,marginLeft:'6px'}} name='chevron down' /></Label>} />
  // } else if (props.tags == 'Anaqtuuvak' || props.tags == 'Nuvuk' || props.tags == 'Tikiġaq' || props.tags == 'Ulġuniq') {
  //   return <Popup position='bottom center' on='click' content={<span style={{fontSize:'15px'}}>{english}</span>} trigger={<Label basic size='mini' style={{color:'#5f5f5f',marginTop:'2px',whiteSpace:'nowrap'}}>{upperCase}<Icon style={{fontSize:'9px',margin:0,padding:0,marginLeft:'6px'}} name='chevron down' /></Label>} />
  // } else if (props.tags.length == 2) {
  //   return <Popup position='bottom right' on='click' content={<span style={{fontSize:'15px'}}>{english}</span>} trigger={<Label size='mini' style={{backgroundColor:'#f3f3f3',marginTop:'2px',whiteSpace:'nowrap'}}>{upperCase}<Icon style={{fontSize:'9px',margin:0,padding:0,marginLeft:'6px'}} name='chevron down' /></Label>} />
  // } else if (props.tags == 'Grammar Year 1') {
  //   return null
  // } else if (english.length == 0) {
  //   return <Label size='mini' style={{backgroundColor:'#f3f3f3',marginTop:'2px',whiteSpace:'nowrap'}}>{upperCase}</Label>
  // } else if (props.tags == '¤unconfirmed') {
  //   return <Popup position='bottom center' on='click' content={<span style={{fontSize:'15px'}}>{english}</span>} trigger={<Label size='mini' style={{backgroundColor:'#f3f3f3',marginTop:'2px',whiteSpace:'nowrap'}}>{upperCase}<Icon style={{fontSize:'9px',margin:0,padding:0,marginLeft:'6px'}} name='chevron down' /></Label>} />
  // } else if (props.tags == 'res' || props.tags == 'ext' || props.tags == 'not' || props.tags == 'tat') {
  //   return <Popup position='bottom center' on='click' content={<span style={{fontSize:'15px'}}>{english}</span>} trigger={<Label size='mini' style={{backgroundColor:'#f3f3f3',whiteSpace:'nowrap',fontFamily:customFontFam,fontSize:'13px',fontWeight:'500',padding:'3px 7px'}}>{upperCase}<Icon style={{fontSize:'9px',margin:0,padding:0,marginLeft:'6px'}} name='chevron down' /></Label>} />
  // } else if (props.tags == 'see examples1') {
  //   return <Popup position='bottom center' on='click' content={<span style={{fontSize:'15px'}}>{tagDict['see examples1'][3].map((k)=>{return <div style={{display:'flex',fontFamily:customFontFam}}><div style={{flex:2}}>{k[0]}</div><div style={{flex:5,color:'#737373'}}>{k[1]}</div></div>})}</span>} trigger={<Label size='mini' style={{backgroundColor:'#f3f3f3',whiteSpace:'nowrap'}}>{upperCase}<Icon style={{fontSize:'9px',margin:0,padding:0,marginLeft:'6px'}} name='chevron down' /></Label>} />
  // } else if (props.tags == 'see examples2') {
  //   return <Popup position='bottom center' on='click' content={<span style={{fontSize:'15px'}}>{tagDict['see examples2'][3].map((k)=>{return <div style={{display:'flex',fontFamily:customFontFam}}><div style={{flex:4}}>{k[0]}</div><div style={{flex:5,color:'#737373'}}>{k[1]}</div></div>})}</span>} trigger={<Label size='mini' style={{backgroundColor:'#f3f3f3',whiteSpace:'nowrap'}}>{upperCase}<Icon style={{fontSize:'9px',margin:0,padding:0,marginLeft:'6px'}} name='chevron down' /></Label>} />
  // } else if (props.tags == 'robj') {
  //   return <Popup position='bottom center' on='click' content={<span style={{fontSize:'15px'}}>{english}</span>} trigger={<Label size='mini' style={{fontSize:'8.2px',cursor:'pointer',backgroundColor:'#eedede',marginLeft:'5px',whiteSpace:'nowrap'}}>{upperCase}<Icon style={{fontSize:'9px',margin:0,padding:0,marginLeft:'6px'}} name='chevron down' /></Label>} />
  // } else if (props.tags == 'rsub') {
  //   return <Popup position='bottom left' on='click' content={<span style={{fontSize:'15px'}}>{english}</span>} trigger={<Label size='mini' style={{fontSize:'8.2px',cursor:'pointer',backgroundColor:'#eedede',marginLeft:'5px',whiteSpace:'nowrap'}}>{upperCase}<Icon style={{fontSize:'9px',margin:0,padding:0,marginLeft:'6px'}} name='chevron down' /></Label>} />
  // } else if (props.tags.includes('adv-') || props.tags.includes('pro-')) {
  //   return <Popup position='bottom center' on='click' content={<span style={{fontSize:'15px'}}>{english}</span>} trigger={<Label size='mini' style={{backgroundColor:'#f3f3f3',whiteSpace:'nowrap'}}>{upperCase}<Icon style={{fontSize:'9px',margin:0,padding:0,marginLeft:'6px'}} name='chevron down' /></Label>} />
    } else {
      return <Popup position='bottom center' on='click' disabled={size === 'medium'} content={<div><span style={{fontSize:'15px'}}>{english}</span><div style={{marginTop:'10px'}}>See <Link target="_blank" to={{pathname: '/legend'}}><span style={{paddingBottom:'1px',borderBottom:'1px solid #4183c4'}}>{'Legend'}</span></Link></div></div>} trigger={<Label size={size} style={{backgroundColor:'#f3f3f3',marginTop:'2px',whiteSpace:'nowrap',cursor:'pointer'}}>{upperCase.replaceAll('_',' ')}<Icon style={{fontSize:'9px',margin:0,padding:0,marginLeft:'6px'}} name='chevron down' /></Label>} />
    }
  } else {
    return <Popup position='bottom center' on='click' disabled={size === 'medium'} content={<div><span style={{fontSize:'15px'}}>{english}</span><div style={{marginTop:'10px'}}>See <Link target="_blank" to={{pathname: '/legend'}}><span style={{paddingBottom:'1px',borderBottom:'1px solid #4183c4'}}>{'Legend'}</span></Link></div></div>} trigger={<Label size={size} style={{backgroundColor:'#f3f3f3',marginTop:'2px',whiteSpace:'nowrap',cursor:'pointer'}}>{upperCase.replaceAll('_',' ')}<Icon style={{fontSize:'9px',margin:0,padding:0,marginLeft:'6px'}} name='chevron down' /></Label>} />
  }



}


// export const WordItem = (props) => {
//   console.log(props.word)
//   let word = props.word;
//   let isNoun = true;
//   // let isVerb = props.tags.includes('verb');
//   // let isParticle = props.tags.includes('particle');
//   // let isExclamation = props.tags.includes('exclamation');
//   // let isConjunction = props.tags.includes('conjunction');
//   // let isAdverb = props.tags.includes('adverb');
//   // let isPredicate = props.tags.includes('predicate');
//   // let isDemonstrative = props.tags.includes('demonstrative');
//   // let isInterjection = props.tags.includes('interjection');


//   // let isPostbase = props.tags.includes('postbase');
//   // let isEnclitic = props.tags.includes('enclitic');

//   // let isExpression = props.tags.includes('expression');
//   // let isCommon = props.tags.includes('grammar');
//   // let isHBC = props.tags.includes('Hooper Bay Chevak');


//   return (
//     <List.Item key={word.keyString}>
//     <Link to={{pathname: '/' + word.url, state: { word: word.keyString, }}}>
//       <List.Content>
//         <List.Header style={{display:'flex',fontSize:'16px',paddingBottom:'4px',fontFamily:"Roboto,'Helvetica Neue',Arial,Helvetica,sans-serif"}}>
//           {word.keySplit.map((w,index) => 
//               <span style={{'paddingRight':'3px'}}>
//               {/*{console.log(w)}*/}
//               {this.processStyledText(w[0])}
//               {w[1][0] !== '' ?
//                   <span style={{marginLeft:'3px',fontWeight:'100'}}>{"("+w[1].join(', ')+")"}</span>
//                 :
//                 (index == word.keySplit.length-1 ?
//                   ''
//                   :
//                   ', '
//                 )
//               }
//                 <span style={{ 'marginLeft': '15px'}}>  
//                   {isNoun ? <Label size='mini' style={{backgroundColor:'#7F90B0',color:'white'}}>NOUN</Label> : ''}
//                 </span>
//               </span>
//             )}
//         </List.Header>
//         <List.Description style={{fontSize:'16px',fontWeight:'400'}}>{word.definitionString}</List.Description>
//       </List.Content>
//     </Link>
//     </List.Item>
//   );
// }
